module.exports = __webpack_public_path__ + "img/tool_icon6.20167d8b.svg";